import { format } from '@office-start/string-formatter-utility';
// This string is used as title of dilog iframe
export var formatTaskModuleTitle = function (title, appName, dialogType) {
    if (title) {
        return undefined;
    }
    switch (dialogType) {
        case 'UPGRADE':
        case 'ABOUT':
            return format(title, appName);
        default:
            return title;
    }
};
//# sourceMappingURL=formatTaskModuleTitle.js.map